import { useSyncExternalStore } from "react";

// Look of the staff app, chosen per browser (Account menu -> Theme). Presentation only.
// Glass is the current staff default; each browser can choose another look afterwards.
// The choice lives on <html data-ui-theme> (data-theme already belongs to the role theme in AuthContext).
// Catalogue fonts are requested only when that theme is active, so Classic users download nothing extra.
export const THEMES = [["classic", "Classic"], ["catalogue", "Catalogue"], ["glass", "Glass"]];
const KEY = "core-theme";
const GLASS_ROLLOUT_KEY = "core-theme-glass-default-20261027";
const EVENT = "core:theme";
const FONT_ID = "core-theme-catalogue-fonts";
const FONT_HREF = "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600&family=Newsreader:ital,opsz,wght@0,72,300;0,72,500;1,72,300&display=swap";

export function getTheme() {
  try {
    const saved = localStorage.getItem(KEY);
    return saved === "classic" || saved === "catalogue" || saved === "glass" ? saved : "glass";
  } catch { return "glass"; }
}

// Move every existing staff browser to Glass once. Later selections remain theirs.
export function activateGlassDefaultOnce() {
  try {
    if (localStorage.getItem(GLASS_ROLLOUT_KEY) === "1") return;
    localStorage.setItem(KEY, "glass");
    localStorage.setItem(GLASS_ROLLOUT_KEY, "1");
  } catch { /* Browsers without storage still use the Glass fallback. */ }
}

// The customer gallery (galeri. / /katalog) and the printer's download page (/p/) keep their own look.
function isStaffApp() {
  if (typeof window === "undefined") return false;
  const { hostname, pathname } = window.location;
  return !hostname.startsWith("galeri.") && !/^\/katalog(\/|$)/.test(pathname) && !/^\/p\//.test(pathname);
}

function ensureFonts() {
  if (document.getElementById(FONT_ID)) return;
  const link = document.createElement("link");
  link.id = FONT_ID;
  link.rel = "stylesheet";
  link.href = FONT_HREF;
  document.head.appendChild(link);
}

export function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if ((theme === "catalogue" || theme === "glass") && isStaffApp()) {
    if (theme === "catalogue") ensureFonts();
    root.dataset.uiTheme = theme;
  } else {
    delete root.dataset.uiTheme;
  }
}

export function setTheme(theme) {
  const next = theme === "catalogue" || theme === "glass" ? theme : "classic";
  try { localStorage.setItem(KEY, next); } catch { /* private mode: the choice lasts for this page only */ }
  applyTheme(next);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: next }));
}

const subscribe = (cb) => { window.addEventListener(EVENT, cb); return () => window.removeEventListener(EVENT, cb); };
export function useUiTheme() {
  return useSyncExternalStore(subscribe, getTheme, () => "glass");
}

// Imported first in src/index.js: the attribute is set before React paints anything.
activateGlassDefaultOnce();
applyTheme(getTheme());
